// API 狀態管理
export const INIT_SEND_API_STATUS = 'INIT_SEND_API_STATUS';

// 500api出錯回應
export const SERVER_ERROR_500 = 'SERVER_ERROR_500';

// 登出請求
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

// API Loading
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';

// 登入請求
export const ADMIN_LOGIN_SOURCE = 'ADMIN_LOGIN_SOURCE';
export const ADMIN_LOGIN_REQUEST = 'ADMIN_LOGIN_REQUEST';
export const ADMIN_LOGIN_SUCCESS = 'ADMIN_LOGIN_SUCCESS';
export const ADMIN_LOGIN_FAILURE = 'ADMIN_LOGIN_FAILURE';

export const SWITCH_REMEMBER_ME = 'SWITCH_REMEMBER_ME';
export const UPDATE_STORE = 'UPDATE_STORE';
// 員工列表 新增 刪除
export const INIT_STAFF_LIST = 'INIT_STAFF_LIST';
export const STAFF_LIST_REQUEST = 'STAFF_LIST_REQUEST';
export const STAFF_LIST_SUCCESS = 'STAFF_LIST_SUCCESS';
export const STAFF_LIST_FAILURE = 'STAFF_LIST_FAILURE';
export const STAFF_STATUS_SWITCH = 'STAFF_STATUS_SWITCH';
export const SORT_STAFF_LIST = 'SORT_STAFF_LIST';
// 假單列表
export const GET_ALL_LEAVEREC_SUCCESS = 'GET_ALL_LEAVEREC_SUCCESS';
export const GET_ALL_LEAVEREC_FAILURE = 'GET_ALL_LEAVEREC_FAILURE';
export const GET_ALL_LEAVEREC_REQUEST = 'GET_ALL_LEAVEREC_REQUEST';

export const GET_ALL_OVERTIMEREC_SUCCESS = 'GET_ALL_OVERTIMEREC_SUCCESS';
export const GET_ALL_OVERTIMEREC_FAILURE = 'GET_ALL_OVERTIMEREC_FAILURE';
export const GET_ALL_OVERTIMEREC_REQUEST = 'GET_ALL_OVERTIMEREC_REQUEST';

export const ADD_STAFF_REQUEST = 'ADD_STAFF_REQUEST';
export const ADD_STAFF_SUCCESS = 'ADD_STAFF_SUCCESS';
export const ADD_STAFF_FAILURE = 'ADD_STAFF_FAILURE';

export const EDIT_STAFF_REQUEST = 'EDIT_STAFF_REQUEST';
export const EDIT_STAFF_SUCCESS = 'EDIT_STAFF_SUCCESS';
export const EDIT_STAFF_FAILURE = 'EDIT_STAFF_FAILURE';

// 職位列表
export const INIT_JOBTYPE_LIST = 'INIT_JOBTYPE_LIST';
export const JOBTYPE_LIST_REQUEST = 'JOBTYPE_LIST_REQUEST';
export const JOBTYPE_LIST_SUCCESS = 'JOBTYPE_LIST_SUCCESS';
export const JOBTYPE_LIST_FAILURE = 'JOBTYPE_LIST_FAILURE';

// 登入員工預期工時編輯
export const INIT_NEXT_SHIFT = 'INIT_NEXT_MONTH_SHIFT';
export const NEXT_SHIFT_REQUEST = 'NEXT_MONTH_SHIFT_REQUEST';
export const NEXT_SHIFT_SUCCESS = 'NEXT_MONTH_SHIFT_SUCCESS';
export const NEXT_SHIFT_FAILURE = 'NEXT_MONTH_SHIFT_FAILURE';

// 新增上班時段
export const ADD_NEXT_WORK_TIME_REQUEST = 'ADD_NEXT_WORK_TIME_REQUEST';
export const ADD_NEXT_WORK_TIME_SUCCESS = 'ADD_NEXT_WORK_TIME_SUCCESS';
export const ADD_NEXT_WORK_TIME_FAILURE = 'ADD_NEXT_WORK_TIME_FAILURE';

// 編輯上班時段
export const EDIT_NEXT_WORK_TIME_REQUEST = 'EDIT_NEXT_WORK_TIME_REQUEST';
export const EDIT_NEXT_WORK_TIME_SUCCESS = 'EDIT_NEXT_WORK_TIME_SUCCESS';
export const EDIT_NEXT_WORK_TIME_FAILURE = 'EDIT_NEXT_WORK_TIME_FAILURE';

// 刪除上班時段
export const DELETE_NEXT_WORK_TIME_REQUEST = 'DELETE_NEXT_WORK_TIME_REQUEST';
export const DELETE_NEXT_WORK_TIME_SUCCESS = 'DELETE_NEXT_WORK_TIME_SUCCESS';
export const DELETE_NEXT_WORK_TIME_FAILURE = 'DELETE_NEXT_WORK_TIME_FAILURE';

// 支援班表
export const INIT_SUPPORT_SCHEDULE_SHIFT = 'INIT_SUPPORT_SCHEDULE_SHIFT';
export const SUPPORT_SCHEDULE_SHIFT_REQUEST = 'SUPPORT_SCHEDULE_SHIFT_REQUEST';
export const SUPPORT_SCHEDULE_SHIFT_SUCCESS = 'SUPPORT_SCHEDULE_SHIFT_SUCCESS';
export const SUPPORT_SCHEDULE_SHIFT_FAILURE = 'SUPPORT_SCHEDULE_SHIFT_FAILURE';

// 支援班表 Date
export const INIT_SUPPORT_SCHEDULE_SHIFT_BY_DATE = 'INIT_SUPPORT_SCHEDULE_SHIFT_BY_DATE';
export const SUPPORT_SCHEDULE_SHIFT_REQUEST_BY_DATE = 'SUPPORT_SCHEDULE_SHIFT_REQUEST_BY_DATE';
export const SUPPORT_SCHEDULE_SHIFT_SUCCESS_BY_DATE = 'SUPPORT_SCHEDULE_SHIFT_SUCCESS_BY_DATE';
export const SUPPORT_SCHEDULE_SHIFT_FAILURE_BY_DATE = 'SUPPORT_SCHEDULE_SHIFT_FAILURE_BY_DATE';

// 個人簽到表
export const INIT_ATTENDANCE_SHEET = 'INIT_ATTENDANCE_SHEET';
export const ATTENDANCE_SHEET_REQUEST = 'ATTENDANCE_SHEET_REQUEST';
export const ATTENDANCE_SHEET_SUCCESS = 'ATTENDANCE_SHEET_SUCCESS';
export const ATTENDANCE_SHEET_FAILURE = 'ATTENDANCE_SHEET_FAILURE';

// 總簽到表
export const INIT_ALL_ATTENDANCE_SHEET = 'INIT_ATTENDANCE_SHEET';
export const ALL_ATTENDANCE_SHEET_REQUEST = 'ALL_ATTENDANCE_SHEET_REQUEST';
export const ALL_ATTENDANCE_SHEET_SUCCESS = 'ALL_ATTENDANCE_SHEET_SUCCESS';
export const ALL_ATTENDANCE_SHEET_FAILURE = 'ALL_ATTENDANCE_SHEET_FAILURE';

// 預期工時表
export const INIT_EXPECTED_WORK_SHEET = 'INIT_EXPECTED_WORK_SHEET';
export const EXPECTED_WORK_SHEET_REQUEST = 'EXPECTED_WORK_SHEET_REQUEST';
export const EXPECTED_WORK_SHEET_SUCCESS = 'EXPECTED_WORK_SHEET_SUCCESS';
export const EXPECTED_WORK_SHEET_FAILURE = 'EXPECTED_WORK_SHEET_FAILURE';

// 依日期的預期工時
export const INIT_EXPECTED_WORKBYDAY_SHEET = 'INIT_EXPECTED_WORKBYDAY_SHEET';
export const EXPECTED_WORKBYDAY_SHEET_REQUEST = 'EXPECTED_WORKBYDAY_SHEET_REQUEST';
export const EXPECTED_WORKBYDAY_SHEET_SUCCESS = 'EXPECTED_WORKBYDAY_SHEET_SUCCESS';
export const EXPECTED_WORKBYDAY_SHEET_FAILURE = 'EXPECTED_WORKBYDAY_SHEET_FAILURE';

// 最終工時表
export const INIT_FINAL_WORK_SHEET = 'INIT_FINAL_WORK_SHEET';
export const FINAL_WORK_SHEET_REQUEST = 'FINAL_WORK_SHEET_REQUEST';
export const FINAL_WORK_SHEET_SUCCESS = 'FINAL_WORK_SHEET_SUCCESS';
export const FINAL_WORK_SHEET_FAILURE = 'FINAL_WORK_SHEET_FAILURE';

// 依日期的最終工時
export const INIT_FINAL_WORKBYDAY_SHEET = 'INIT_FINAL_WORKBYDAY_SHEET';
export const FINAL_WORKBYDAY_SHEET_REQUEST = 'FINAL_WORKBYDAY_SHEET_REQUEST';
export const FINAL_WORKBYDAY_SHEET_SUCCESS = 'FINAL_WORKBYDAY_SHEET_SUCCESS';
export const FINAL_WORKBYDAY_SHEET_FAILURE = 'FINAL_WORKBYDAY_SHEET_FAILURE';


// 取得欲調整的班表
export const INIT_ADJUSTMENT_SCHEDULE_SHEET = 'INIT_ADJUSTMENT_SCHEDULE_SHEET';
export const ADJUSTMENT_SCHEDULE_SHEET_REQUEST = 'ADJUSTMENT_SCHEDULE_SHEET_REQUEST';
export const ADJUSTMENT_SCHEDULE_SHEET_SUCCESS = 'ADJUSTMENT_SCHEDULE_SHEET_SUCCESS';
export const ADJUSTMENT_SCHEDULE_SHEET_FAILURE = 'ADJUSTMENT_SCHEDULE_SHEET_FAILURE';

// 取得欲調整的班表 by 日期
export const INIT_ADJUSTMENT_SCHEDULE_DETAIL_SHEET = 'INIT_ADJUSTMENT_SCHEDULE_DETAIL_SHEET';
export const ADJUSTMENT_SCHEDULE_SHEET_DETAIL_REQUEST = 'ADJUSTMENT_SCHEDULE_SHEET_DETAIL_REQUEST';
export const ADJUSTMENT_SCHEDULE_SHEET_DETAIL_SUCCESS = 'ADJUSTMENT_SCHEDULE_SHEET_DETAIL_SUCCESS';
export const ADJUSTMENT_SCHEDULE_SHEET_DETAIL_FAILURE = 'ADJUSTMENT_SCHEDULE_SHEET_DETAIL_FAILURE';


// 調班時 新增上班人員
export const ADD_STAFF_IN_ADJUST_SHIFT_REQUEST = 'ADD_STAFF_IN_ADJUST_SHIFT_REQUEST';
export const ADD_STAFF_IN_ADJUST_SHIFT_SUCCESS = 'ADD_STAFF_IN_ADJUST_SHIFT_SUCCESS';
export const ADD_STAFF_IN_ADJUST_SHIFT_FAILURE = 'ADD_STAFF_IN_ADJUST_SHIFT_FAILURE';

// 調班時 獲得全部的員工
export const GET_ALL_STAFF_REQUEST = 'GET_ALL_STAFF_REQUEST';
export const GET_ALL_STAFF_SUCCESS = 'GET_ALL_STAFF_SUCCESS';
export const GET_ALL_STAFF_FAILURE = 'GET_ALL_STAFF_FAILURE';

// 調班時 刪除上班人員
export const DELETE_STAFF_IN_ADJUST_REQUEST = 'DELETE_STAFF_IN_ADJUST_REQUEST';
export const DELETE_STAFF_IN_ADJUST_SUCCESS = 'DELETE_STAFF_IN_ADJUST_SUCCESS';
export const DELETE_STAFF_IN_ADJUST_FAILURE = 'DELETE_STAFF_IN_ADJUST_FAILURE';


// 調班時 調整工作人員時段
export const EDIT_STAFF_WORKTIME_IN_ADJUST_REQUEST = 'EDIT_STAFF_WORKTIME_IN_ADJUST_REQUEST';
export const EDIT_STAFF_WORKTIME_IN_ADJUST_SUCCESS = 'EDIT_STAFF_WORKTIME_IN_ADJUST_SUCCESS';
export const EDIT_STAFF_WORKTIME_IN_ADJUST_FAILURE = 'EDIT_STAFF_WORKTIME_IN_ADJUST_FAILURE';

// 獲得員工薪資列表
export const GET_STAFF_SALARY_LIST_REQUEST = 'GET_STAFF_SALARY_LIST_REQUEST';
export const GET_STAFF_SALARY_LIST_SUCCESS = 'GET_STAFF_SALARY_LIST_SUCCESS';
export const GET_STAFF_SALARY_LIST_FAILURE = 'GET_STAFF_SALARY_LIST_FAILURE';


// 新增員工上班紀錄
export const ADD_STAFF_WORK_RECORD_REQUEST = 'ADD_STAFF_WORK_RECORD_REQUEST';
export const ADD_STAFF_WORK_RECORD_SUCCESS = 'ADD_STAFF_WORK_RECORD_SUCCESS';
export const ADD_STAFF_WORK_RECORD_FAILURE = 'ADD_STAFF_WORK_RECORD_FAILURE';


// 補簽到
export const RE_ADD_STAFF_WORK_RECORD_REQUEST = 'RE_ADD_STAFF_WORK_RECORD_REQUEST';
export const RE_ADD_STAFF_WORK_RECORD_SUCCESS = 'RE_ADD_STAFF_WORK_RECORD_SUCCESS';
export const RE_ADD_STAFF_WORK_RECORD_FAILURE = 'RE_ADD_STAFF_WORK_RECORD_FAILURE';


// 取得彙整資料
export const INIT_PEOPLESTATICTICS_SHEET = 'INIT_PEOPLESTATICTICS_SHEET';
export const PEOPLESTATICTICS_SHEET_DETAIL_REQUEST = 'PEOPLESTATICTICS_SHEET_DETAIL_REQUEST';
export const PEOPLESTATICTICS_SHEET_DETAIL_SUCCESS = 'PEOPLESTATICTICS_SHEET_DETAIL_SUCCESS';
export const PEOPLESTATICTICS_SHEET_DETAIL_FAILURE = 'PEOPLESTATICTICS_SHEET_DETAIL_FAILURE';

// 新增打卡紀錄
export const ADD_PUNCHTIME_RECORD_REQUEST = 'ADD_PUNCHTIME_RECORD_REQUEST';
export const ADD_PUNCHTIME_RECORD_SUCCESS = 'ADD_PUNCHTIME_RECORD_SUCCESS';
export const ADD_PUNCHTIME_RECORD_FAILURE = 'ADD_PUNCHTIME_RECORD_FAILURE';


// 更新打卡紀錄
export const EDIT_PUNCHTIME_RECORD_REQUEST = 'ADD_PUNCHTIME_RECORD_REQUEST';
export const EDIT_PUNCHTIME_RECORD_SUCCESS = 'ADD_PUNCHTIME_RECORD_SUCCESS';
export const EDIT_PUNCHTIME_RECORD_FAILURE = 'ADD_PUNCHTIME_RECORD_FAILURE';

// 更新打卡紀錄
export const GET_SIGNINOUT_REQUEST = 'GET_SIGNINOUT_REQUEST';
export const GET_SIGNINOUT_SUCCESS = 'GET_SIGNINOUT_SUCCESS';
export const GET_SIGNINOUT_FAILURE = 'GET_SIGNINOUT_FAILURE';

//DAILY_COST_BY_HOUR
export const DAILY_COST_BY_HOUR_REQUEST = 'DAILY_COST_BY_HOUR_REQUEST';
export const DAILY_COST_BY_HOUR_SUCCESS = 'DAILY_COST_BY_HOUR_SUCCESS';
export const DAILY_COST_BY_HOUR_FAILURE = 'DAILY_COST_BY_HOUR_FAILURE';

export const HOUR_COST_CHART_REQUEST = 'HOUR_COST_CHART_REQUEST';
export const HOUR_COST_CHART_SUCCESS = 'HOUR_COST_CHART_SUCCESS';
export const HOUR_COST_CHART_FAILURE = 'HOUR_COST_CHART_FAILURE';

export const MIN30_COST_CHART_REQUEST = 'MIN30_COST_CHART_REQUEST';
export const MIN30_COST_CHART_SUCCESS = 'MIN30_COST_CHART_SUCCESS';
export const MIN30_COST_CHART_FAILURE = 'MIN30_COST_CHART_FAILURE';

export const MIN30BAR_COST_CHART_REQUEST = 'MIN30BAR_COST_CHART_REQUEST';
export const MIN30BAR_COST_CHART_SUCCESS = 'MIN30BAR_COST_CHART_SUCCESS';
export const MIN30BAR_COST_CHART_FAILURE = 'MIN30BAR_COST_CHART_FAILURE';

export const ACCUMULATE_COST_CHART_REQUEST = 'ACCUMULATE_COST_CHART_REQUEST';
export const ACCUMULATE_COST_CHART_SUCCESS = 'ACCUMULATE_COST_CHART_SUCCESS';
export const ACCUMULATE_COST_CHART_FAILURE = 'ACCUMULATE_COST_CHART_FAILURE';